import React, { useState } from 'react';
import StoreRequestPopup from './StoreRequestPopup';
import './StoreGoesLive.css';

const StoreGoesLive = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleGetStartedClick = () => {
    setIsPopupOpen(true);
  };

  const steps = [
    {
      number: "1",
      title: "Onboarding Call",
      description: "We understand your brand, business category, domain status, payment method, delivery setup, and any key requirements needed to prepare your online store.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/>
          <path d="m21.854 2.147-10.94 10.939"/>
        </svg>
      ),
      gradient: "gradient-primary",
      delay: "0ms"
    },
    {
      number: "2",
      title: "We Prepare Your Store",
      description: "Our team sets up your e-commerce store structure, branding foundation, essential pages, cart, checkout, payment options, delivery settings, and WhatsApp support.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/>
          <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/>
          <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/>
        </svg>
      ),
      gradient: "gradient-coral",
      delay: "80ms"
    },
    {
      number: "3",
      title: "Dashboard Handover",
      description: "Once the store shell is ready, we share your store link and dashboard access so you can add your own products, images, categories, banners, content, and store details.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      ),
      gradient: "gradient-primary",
      delay: "160ms"
    },
    {
      number: "4",
      title: "Review & Go Live",
      description: "After you complete your store content, we review the setup, make sure everything is ready, and then your branded e-commerce website goes live.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09"/>
          <path d="M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z"/>
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05"/>
        </svg>
      ),
      gradient: "gradient-coral",
      delay: "240ms"
    }
  ];

  return (
    <>
      <section className="store-goes-live">
        <div className="container-px">
          {/* Header Section */}
          <div className="text-center max-w-2xl mx-auto">
            <div className="flex justify-center">
              <span className="badge-sparkle">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/>
                  <path d="M20 2v4"/>
                  <path d="M22 4h-4"/>
                  <circle cx="4" cy="20" r="2"/>
                </svg>
                How It Works
              </span>
            </div>
            
            <h2 className="section-title-live">
              How Your Store <span className="text-gradient">Goes Live</span>
            </h2>
          </div>

          {/* Steps Grid */}
          <div className="steps-wrapper">
            {/* Dashed Line - Desktop Only */}
            <div className="dashed-line">
              <svg width="100%" height="3" preserveAspectRatio="none" className="overflow-visible">
                <line x1="0" y1="1.5" x2="100%" y2="1.5" stroke="currentColor" className="text-border" strokeWidth="2" strokeDasharray="6 6" />
              </svg>
            </div>

            {/* Steps Grid */}
            <div className="steps-grid">
              {steps.map((step, index) => (
                <div key={index} className="step-item animate-fade-up" style={{ animationDelay: step.delay }}>
                  <div className="step-circle-wrapper">
                    <div className={`step-glow ${step.gradient}`}></div>
                    <div className="step-circle">
                      {step.icon}
                      <span className={`step-number ${step.gradient}`}>
                        {step.number}
                      </span>
                    </div>
                  </div>
                  
                  <div className="step-content">
                    <h3 className="step-title">{step.title}</h3>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Banner */}
          <div className="cta-banner-wrapper">
            <div className="cta-banner">
              <div className="cta-glow"></div>
              
              <div className="cta-content-inner">
                <div className="cta-icon-wrapper">
                  <div className="cta-icon gradient-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M12 6v6l4 2"/>
                    </svg>
                  </div>
                </div>
                
                <div className="cta-text-wrapper">
                  <p className="cta-title">Your 3-day handover starts after onboarding and confirmation of required details.</p>
                  <p className="cta-subtitle">Once we hand over your store and dashboard access, you can add your content and go live.</p>
                </div>
                
                <button className="cta-button-desktop shine-on-hover" onClick={handleGetStartedClick}>
                  Get Started
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14"/>
                    <path d="m12 5 7 7-7 7"/>
                  </svg>
                </button>
              </div>
              
              <button className="cta-button-mobile" onClick={handleGetStartedClick}>
                Get Started
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Store Request Popup */}
      <StoreRequestPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default StoreGoesLive;